<template>
  <div class="wrap1">
    <h2 class="common-title">{{ $t('381') }}</h2>
    <div class="wrap-content">
      <div ref="top">
        <div class="search">
          <div class="search-left">
            <el-button size="small" @click="handleSearch">{{ $t('415') }}</el-button>
            <el-input
              class="search-input"
              :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
              prefix-icon="el-icon-search"
              size="small"
              v-model="dataForm.search_word"
            >
            </el-input>
            <el-button size="small" type="primary" @click="handleSubmit">{{ $t('69') }}</el-button>
          </div>
          <div class="search-center"></div>
          <div class="search-right">
            <!-- 年度数据归档 -->
            <el-button size="small" @click="handleFile" v-if="$p('menu.payroll.salary.edit')">{{
              $t('payroll_management_61')
            }}</el-button>
            <!--下载 -->
            <el-dropdown trigger="click" @command="handleCommand" v-if="$p('menu.payroll.salary.export')">
              <el-button size="small">{{ $t('1373') }}</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="2">{{ $t('913') }}</el-dropdown-item>
                <el-dropdown-item command="1">{{ $t('i18n.d61fa2ec088d461e86ce3ac9ca132f0c') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!--批量调薪 -->
            <el-button size="small" @click="handleBatchSalary" v-if="$p('menu.payroll.salary.edit')">{{
              $t('i18n.5a6653a1d4ea4108ab13f868622bd90a')
            }}</el-button>
            <!--批量导入 -->
            <el-button size="small" @click="handleImport" v-if="$p('menu.payroll.salary.edit')">{{
              $t('bulkImport')
            }}</el-button>
          </div>
        </div>
        <div class="wrap1-tip">
          <i class="el-icon-info icon-info"></i>
          <p>{{ $t('payroll_salary_2') }}</p>
        </div>
      </div>
      <el-table :data="page.list" v-load="loading" :height="tableHeight" @sort-change="handlerSort">
        <!-- 姓名-->
        <el-table-column
          fixed="left"
          prop="staff_name"
          :label="$t('22')"
          min-width="240px"
          sortable="custom"
        ></el-table-column>
        <!-- 手机号-->
        <el-table-column prop="mobile" :label="$t('825')" min-width="168px"></el-table-column>
        <!-- 工号-->
        <el-table-column prop="staff_code" :label="$t('25')" min-width="150px" sortable="custom"></el-table-column>
        <!-- 部门-->
        <el-table-column prop="department_name" :label="$t('932')" min-width="240px"></el-table-column>
        <!-- 职位-->
        <el-table-column prop="job_title_name" :label="$t('24')" min-width="240px"></el-table-column>
        <!-- 员工属性-->
        <el-table-column prop="formal_text" :label="$t('32')" min-width="216px"></el-table-column>
        <!-- 结算方式-->
        <el-table-column prop="settlement_type_text" :label="$t('33')" min-width="192px"></el-table-column>
        <!-- 支付方式-->
        <el-table-column prop="salary_method_text" :label="$t('34')" min-width="192px"></el-table-column>
        <!-- 在职状态-->
        <el-table-column prop="state_text" :label="$t('state')" min-width="192px"></el-table-column>
        <!-- 入职日期-->
        <el-table-column prop="hire_date" :label="$t('28')" min-width="168px" sortable="custom"></el-table-column>
        <!-- 离职日期-->
        <el-table-column prop="leave_date" :label="$t('29')" min-width="168px"></el-table-column>
        <!-- 操作-->
        <el-table-column :label="$t('70')" fixed="right" min-width="288px">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)" v-if="$p('menu.payroll.salary.edit')">{{
              $t('71')
            }}</el-button>
            <el-button
              v-if="scope.row.settlement_type === '1' && $p('menu.payroll.salary.edit')"
              type="text"
              @click="handleSalary(scope.row)"
              >{{ $t('payroll_management_29') }}</el-button
            >
            <el-dropdown>
              <el-button type="text" class="el-dropdown-link">{{ $t('more') }}...</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleSalaryHistory(scope.row)">
                  <el-button type="text">{{ $t('i18n.8332aec5e5f2411f802b111838a71072') }}</el-button>
                </el-dropdown-item>
                <el-dropdown-item @click.native="handleSalaryRecord(scope.row)">
                  <el-button type="text">{{ $t('payroll_management_30') }}</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        layout="total, sizes, prev, pager, next"
        :page-sizes="pageSizes"
        :total="page.total"
        :current-page="page.currPage"
        :page-size="page.limit"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <search-popup ref="searchPopup" :page-name="pageName" @submit="getSearchData"></search-popup>
    <upload-dialog ref="uploadDialog"></upload-dialog>
    <item-detail ref="detail" :staff-id="staffId" :type="type" @getListData="getListData"></item-detail>
    <setting-salary ref="settingSalary"></setting-salary>
    <change-salary ref="changeSalary"></change-salary>
    <el-dialog
      :title="$t('229')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="696px"
    >
      <div class="dialog-info">
        <div class="info">
          <i class="el-icon-info icon-info"></i>
          <p v-dompurify-html="$t('payroll_salary_10')"></p>
        </div>
        <el-form :model="data" ref="saveYear" class="file-form" label-width="88px">
          <el-form-item
            prop="year"
            :label="$t('1848')"
            :rules="[{ required: true, message: $t('1840'), trigger: 'change' }]"
          >
            <el-date-picker
              class="picker"
              v-model="data.year"
              value-format="yyyy"
              size="small"
              type="year"
              :clearable="false"
              :placeholder="$t('1591')"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">{{ $t('66') }}</el-button>
        <el-button size="small" type="primary" @click="handleSaveYear">{{ $t('67') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('229')"
      :visible.sync="backupsDialogVisible"
      :close-on-click-modal="false"
      append-to-body
      width="696px"
    >
      <div
        class="dialog-info"
        v-dompurify-html="
          $t('18551_43e2622e', {
            year: backupsInfo.year,
            operate_date: backupsInfo.operate_date
          })
        "
      ></div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" :loading="loadingBackups" @click="handleBackups">{{ $t('18551_43e2622d') }}</el-button>
        <el-button size="small" type="primary" @click="backupsDialogVisible = false">{{ $t('66') }}</el-button>
      </span>
    </el-dialog>

    <ExportExcelDialog ref="ExportExcelDialog" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { payrollStaffList, payrollStaffExport, saveYearIncomeArchive, checkYearIncomeArchive } from '@/api/payroll'
import searchPopup from '../compontents/search-popup'
import uploadDialog from './modal/uploadDialog'
import SettingSalary from './modal/setting-salary'
import ChangeSalary from './modal/change-salary'
import itemDetail from '../compontents/detail'
import Pagination from '@/components/pagination'
import ExportExcelDialog from '@/components/ExportExcelDialog'

export default {
  name: 'payrollWage',
  components: {
    searchPopup,
    uploadDialog,
    itemDetail,
    SettingSalary,
    ChangeSalary,
    Pagination,
    [ExportExcelDialog.name]: ExportExcelDialog
  },
  data() {
    return {
      exportLoading: false,
      loading: false,
      dialogVisible: false,
      tableData1: [],
      dataForm: {
        search_word: '',
        department_id: '',
        settlement_type: '',
        formal: '',
        state: '',
        hire_start_date: '',
        hire_end_date: '',
        leave_start_date: '',
        leave_end_date: ''
      },
      pageSizes: [20, 50, 100],
      pageName: 'salary',
      staffId: null,
      type: 'salay',
      sort: '',
      dir: '',
      page: {
        list: [{}],
        currPage: 1,
        limit: 20,
        total: 0
      },
      data: {
        year: ''
      },
      isShowExportExcelDialog: false,
      backupsDialogVisible: false,
      loadingBackups: false,
      backupsInfo: {
        year: '',
        operate_date: ''
      }
    }
  },
  created() {
    this.getListData()
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return this.contentViewHeight - 176
    }
  },
  methods: {
    // 排序
    handlerSort({ prop, order }) {
      this.sort = prop
      this.dir = order
      this.getListData()
    },
    async getListData() {
      this.loading = true
      const res = await payrollStaffList({
        ...this.dataForm,
        sort: this.sort, // 排序相关
        dir: this.dir,
        page: this.page.currPage,
        page_size: this.page.limit
      })
      if (res && res.code === 1) {
        this.page.list = res.data.list
        this.page.total = Number(res.data.total_count)
      }
      this.loading = false
    },
    handleSubmit() {
      this.page.currPage = 1
      this.getListData()
    },
    handleSizeChange(val) {
      this.page.limit = val
      this.getListData()
    },
    handleCurrentChange(val) {
      this.page.currPage = val
      this.getListData()
    },
    handleSearch() {
      this.$refs.searchPopup.init()
    },
    handleImport() {
      this.$refs.uploadDialog.init()
    },
    handleBatchSalary() {
      this.$router.push({
        path: '/payroll/salaryBatch'
      })
    },
    // 年度数据归档
    handleFile() {
      this.dialogVisible = true
    },
    getSearchData(data) {
      this.dataForm = data
      this.page.currPage = 1
      this.page.limit = 100
      this.getListData()
    },
    async handleExport() {
      this.exportLoading = true
      const res = await payrollStaffExport(this.dataForm)
      if (res && res.code === 1) window.open(res.data.file_url, '_parent')
      this.exportLoading = false
    },
    handleSaveYear() {
      this.$refs.saveYear.validate(valid => {
        if (valid) {
          checkYearIncomeArchive({ year: this.data.year }).then(res => {
            if (res && res.code === 1) {
              if (res.data.operate_date && res.data.year) {
                this.dialogVisible = false
                this.backupsInfo.operate_date = res.data.operate_date
                this.backupsInfo.year = res.data.year

                setTimeout(() => {
                  this.backupsDialogVisible = true
                }, 500)
              } else
                saveYearIncomeArchive({ year: this.data.year }).then(res => {
                  if (res && res.code === 1) {
                    this.$message({
                      message: this.$t('818'),
                      type: 'success'
                    })
                    this.dialogVisible = false
                  }
                })
            }
          })
        } else return false
      })
    },
    // 备份并归档
    handleBackups() {
      this.loadingBackups = true
      saveYearIncomeArchive({ year: this.data.year })
        .then(res => {
          if (res && res.code === 1) {
            this.$message({ message: res.message, type: 'success' })
            this.backupsDialogVisible = false
          }
        })
        .finally(() => {
          this.loadingBackups = false
        })
    },
    handleEdit(row) {
      this.staffId = row.staff_id
      this.$refs.detail.init(row)
    },
    handleSalary(row) {
      this.$refs.changeSalary.init(row)
    },
    handleSalaryHistory(row) {
      this.$router.push({
        path: '/payroll/salaryHistory/' + row.staff_id
      })
    },
    handleSalaryRecord(row) {
      this.$router.push({
        path: '/payroll/salaryRecord/' + row.staff_id,
        query: {
          type: row.settlement_type
        }
      })
    },
    handleCommand(relation_type) {
      const params = { relation_type }
      if (this.dataForm.settlement_type) {
        // 1月 2日结 99其他
        params.settlement_type = this.dataForm.settlement_type
      }
      const data = +relation_type === 1 ? {} : this.dataForm
      this.$refs.ExportExcelDialog.init(params, data)
    }
  }
}
</script>

<style lang="less">
.app-main {
  min-width: auto !important;
}
</style>

<style lang="less" scoped>
.wrap1 {
  overflow: hidden;
  overflow-y: auto;
}
.payroll-add-project {
  float: right;
  margin-bottom: 20px;
}
.search {
  display: flex;
  flex-wrap: wrap;
  .search-center {
    flex: 1;
  }
  .search-left {
    padding-bottom: 16px;
  }
  .search-right {
    padding-bottom: 16px;
    .el-button {
      margin-left: 16px;
    }
  }

  .search-input {
    min-width: 320px;
    margin: 0 16px;
  }
}
.el-dropdown-link {
  margin-left: 10px;
}
.payroll-wage {
  height: 100%;
  overflow: hidden;
  &-con {
    display: flex;
    padding: 0;
  }
  &-left {
    width: 240px;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
    ul li {
      height: 30px;
      line-height: 30px;
      cursor: pointer;
    }
  }
  &-main {
    width: calc(~'100% - 240px');
    padding: 10px;
    box-sizing: border-box;
    border-left: 1px solid #ddd;
    flex-direction: column;
    h3 {
      height: 30px;
      line-height: 30px;
      margin: 10px 0;
      i {
        font-style: normal;
        font-size: 12px;
        color: red;
      }
    }
  }
}
.dialog-info {
  .info {
    margin-bottom: 24px;
  }
  .icon-info {
    font-size: 16px;
    float: left;
  }
  p {
    padding-left: 20px;
    line-height: 20px;
  }
  .picker {
    max-width: 304px;
    width: 304px;
  }
}
.icon-info {
  color: #5D51DA;
}
</style>
